import * as React from "react";
import * as S from "@styled";
import { connect } from "react-redux";
import { DispatchType, Utilities } from "../../shared/utilities";
import { updatePromoteResultAs } from "../actions/UpdatePromoteResultAction";
import { State } from "../model/State";
import CustomToggle from "shared/components/CustomToggle";

export const PromoteResultAsEditor: React.FC<PromoteResultProps> = (props) => {

    // Do not remove element parameter
    function onToggleChange(checked: boolean, event: any, id: string) {
        if (checked) {
            if (props.onChange) {
                props.onChange("");
            }
        } else {
            if (props.onChange) {
                props.onChange(null);
            }
        }
    }
    function handlePromotedVariableChagne(event: any) {
        if (props.onChange) {
            props.onChange(event.target.value);
        }
    }

    return (
        <div id={props.id + "-promoteResultAs"}>
            <S.FormGroup $inline={true}>
                <S.Label>
                    {FRENDS.Localizations.PromoteResultAs}
                </S.Label>
                <CustomToggle
                    checked={!props.resultNotLogged && props.shouldPromoteResult as boolean}
                    onChange={onToggleChange}
                    disabled={props.disabled}
                />
            </S.FormGroup>
            {!props.resultNotLogged && props.shouldPromoteResult ? (
                <S.FormGroup>
                    <S.Input
                        disabled={props.disabled}
                        isFullWidth={true}
                        type="text"
                        value={props.promoteResultAs || ""}
                        onChange={handlePromotedVariableChagne}
                    />
                </S.FormGroup>
            ) : null}
        </div>
    );
};

interface PromoteResultProps {
    id: string | undefined;
    promoteResultAs?: string;
    shouldPromoteResult?: boolean;
    onChange?: (value: string | null) => void;
    resultNotLogged?: boolean;
    disabled?: boolean;
}

const mapStateToProps = (state: State, ownProps: PromoteResultProps): PromoteResultProps => {
    const element = state.elements[ownProps.id as string];
    return {
        id: ownProps.id,
        promoteResultAs: element.promoteResultAs,
        shouldPromoteResult: element.promoteResultAs != null,
        resultNotLogged: element.shouldNotLogResult,
        disabled: state.uiState.disableEdit
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: PromoteResultProps): PromoteResultProps => {
    return {
        id: ownProps.id,
        onChange: (value) => dispatch(updatePromoteResultAs(ownProps.id, value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PromoteResultAsEditor);
